import React from 'react';
import './Physiotherapists.css';

const physiotherapistsData = [
  {
    id: 1,
    name: "Dr Zahid Malik",
    experience: "4+ Years",
    experties: "MPT (Neuro)",
    patientsServed: "",
    image: "/assets/images/zahidmalik.jpeg",
    testimonial: ""
  },
  {
    id: 2,
    name: "Dr Faisal Javed",
    experience: "4+ Years",
    experties: "MPT (Ortho)",
    patientsServed: "",
    image: "/assets/images/faisaljaved.jpeg",
    testimonial: ""
  },
  {
    id: 3,
    name: "Dr Harish",
    experience: "4+ Years",
    patientsServed: "",
    experties: "MPT (Ortho)",
    image: "/assets/images/harish.jpeg",
    testimonial: ""
  },
  {
    id: 4,
    name: "Dr Nikhat ",
    experience: "3+ Years",
    patientsServed: "",
    experties: "PT,BPT",
    image: "/assets/images/nikhat.jpeg",
    testimonial: ""
  },
  // {
  //   id: 5,
  //   name: "Shaik Rehana Sulthana",
  //   experience: "7 Years",
  //   patientsServed: "1000+",
  //   image: "/assets/images/shaikrehana.png",
  //   testimonial: "I have had a very fast recovery thanks to dr.Rehana. The team is very quick to respond and assign a physiotherapist. Loved the experience. Totally worth the money."
  // }
];

const Physiotherapists = () => {
  return (
    <section id="physiotherapists" className="physiotherapists">
      <div className="container">
        <div className="section-header">
          <h2>Know Our Physiotherapists</h2>
          <p>Our qualified and experienced Physiotherapists provide trusted support, helping seniors live comfortably at home.</p>
        </div>

        <div className="physiotherapists-grid">
          {physiotherapistsData.map(therapist => (
            <div key={therapist.id} className="therapist-card">
              <div className="therapist-image">
                <img src={therapist.image} alt={therapist.name} />
              </div>
              <div className="therapist-info">
                <h3>{therapist.name}</h3>
                <div className="therapist-stats">
                  <div className="stat">
                    <span className="label">Experience:</span>
                    <span className="value">{therapist.experience}</span>
                  </div>
                  {therapist.experties && therapist.experties.length > 0 && (
                  <div className="stat">
                    <span className="label">Experties:</span>
                    <span className="value">{therapist.experties}</span>
                  </div>
                  )}
                  {therapist.patientsServed && therapist.patientsServed.length > 0 && (
                  <div className="stat">
                    <span className="label">Patient Served:</span>
                    <span className="value">{therapist.patientsServed}</span>
                  </div>
                  )}
                </div>
                {therapist.testimonial && therapist.testimonial.length > 0 && (
                  <div className="testimonial">
                    <h4>Testimonial by the patient:</h4>
                    <p>"{therapist.testimonial}"</p>
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Physiotherapists;